import React from 'react'
import Logo_path from '../../Components/Logo_path'

function ViewMember() {
    return (

        <div className='flex w-full h-full justify-center items-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='flex flex-col w-full items-center'>

                {/* Section 1 logo directory*/}
                <div className='md:w-11/12 w-11/12'>
                    <Logo_path AdminOrHome={'Admin'} Directory={'ViewMember'} />
                </div>

                {/* Section 2 Action button */}
                <div className='md:w-6/12 w-11/12 flex flex-row mt-12'>
                    <div className=' w-full flex flex-row justify-between'>

                        <div className='md:w-3/12 w-3/12 h-12'>
                            <button className='w-full h-full text-white bg-blue-600 rounded-lg hover:text-lg  hover:shadow-2xl transform duration-500 ease-in-out'>Edit</button>
                        </div>

                        <div className='md:w-3/12 w-3/12 h-12'>
                            <button className='w-full h-full border border-blue-700 rounded-lg'>Hide</button>
                        </div>

                        <div className='md:w-3/12 w-3/12 h-12'>
                            <button className='w-full h-full text-white bg-red-600 rounded-lg'>Delete</button>
                        </div>
                    </div>

                </div>

                {/* section 3 description */}
                <div className='flex justify-start md:w-6/12 w-11/12 mt-12'><h1 className='text-xl'>Shri. Pinarayi Vijayan</h1></div>

                <div className='flex justify-start md:w-6/12 w-11/12 mt-6 flex-col'>

                    <div className='w-11/12 flex flex-row mt-6 '>
                        <div className='text-grey-600 flex justify-start md:w-3/12 w-6/12' style={{ color: '#606060' }}> <h2 className=''>District</h2></div>
                        <div className='w-6/12'>Kannur</div>
                    </div>

                    <div className='w-11/12 flex flex-row mt-6 '>
                        <div className='text-grey-600 flex justify-start md:w-3/12 w-6/12' style={{ color: '#606060' }}> <h2 className=''>Constituency</h2></div>
                        <div className='w-6/12'>Dharmadam</div>
                    </div>

                    <div className='w-11/12 flex flex-row mt-6 '>
                        <div className='text-grey-600 flex justify-start md:w-3/12 w-6/12' style={{ color: '#606060' }}> <h2 className=''>Elected Date</h2></div>
                        <div className='w-6/12'>23-05-202</div>
                    </div>



                </div>

                {/* section4 tables */}
                <div className='flex md:w-6/12 w-11/12 mt-12'><h1 className='text-xl'>Positions Handled</h1></div>

                <div className="mt-5 md:w-6/12 w-11/12 mb-10">
                    <table className="w-full border-collapse border ">
                        <thead>
                            <tr>
                                <th className="p-3 border border-white text-left bg-blue-600 text-white">Year</th>
                                <th className="p-3 border border-white text-left bg-blue-600 text-white">Positions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="p-3 border border-blue-600">Year 1</td>
                                <td className="p-3 border border-blue-600">Positions 1</td>
                            </tr>
                            <tr>
                                <td className="p-3 border border-blue-600">Year 2</td>
                                <td className="p-3 border border-blue-600">Positions 2</td>
                            </tr>
                            {/* Add more rows as needed */}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>



    )
}

export default ViewMember